module.exports = __webpack_public_path__ + "img/tijiao.1ab0afc8.png";